import React from 'react'
import ReactTooltip from 'react-tooltip'
import uniqid from 'uniqid'

const Tooltip = ({ width, icon, message }) => {
  const identifier = uniqid()

  return (
    <div className='tooltip-smartchat'>
      <figure
        style={{ width: width ? width : '30px' }}
        data-for={`tooltip-${identifier}`}
        data-tip={message}
      >
        <img src={icon} alt='Tooltip' />
      </figure>
      <ReactTooltip id={`tooltip-${identifier}`} effect='solid' html={true} />
    </div>
  )
}

export default Tooltip
